const Roles = {
  AGENCY: 'agency',
  ADMIN: 'admin',
  SELLER: 'seller',
}

module.exports = {
  Roles,
}
